"use client";
import * as React from "react";
import { useToast } from "@app/providers/toast";
import { useTranslation } from "react-i18next";
import { _WifiOff } from "lucide-react";

export function OfflineDetector() {
  const [_isOffline, setIsOffline] = React.useState(!navigator.onLine);
  const toast = useToast();
  const { t } = useTranslation("common");
  const toastIdRef = React.useRef<string | null>(null);

  React.useEffect(() => {
    const handleOnline = () => {
      setIsOffline(false);
      if (toastIdRef.current) {
        toast.dismiss(toastIdRef.current);
        toastIdRef.current = null;
      }
    };

    const handleOffline = () => {
      setIsOffline(true);
      if (!toastIdRef.current) {
        toastIdRef.current = toast.show(
          t(
            "pwa.offlineNotice",
            "You are offline. Only prepared POS sales can be saved and synchronized later.",
          ),
          "error",
          {
            duration: 0,
            id: "offline-toast",
            preserveOnNavigate: true,
          },
        );
      }
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Initial check
    if (!navigator.onLine) {
      handleOffline();
    }

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [toast, t]);

  return null;
}
